export default __webpack_public_path__ + "media/images/images_v2/filtre-left-fdbe1de5155bfab7e60d5c0993211aa0.png";